// ABOUTME: Offsite-link new-tab policy — anchors whose hostname differs from the storefront get
// target="_blank" and the noreferrer and noopener rel tokens unless marked data-internal-link
// (live-theme ExternalLinks.js behavior, applied once per page load on DOMContentLoaded; SPEED-004).

const setExternalLinkTargets = () => {
  const links = document.links;
  for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname && !links[i].hasAttribute('data-internal-link')) {
      links[i].target = '_blank';
      // Added, not assigned: an anchor's own rel carries meaning the policy must not destroy
      // (nofollow on a paid or user-supplied link, sponsored, me on a social profile, license).
      links[i].relList.add('noreferrer', 'noopener');
    }
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setExternalLinkTargets, { once: true });
} else {
  setExternalLinkTargets();
}
